import { handleCommonErrors, useMutationApi, useQueryApi } from 'utils/api'

import type { CommonResponse } from 'types/api'
import type {
  ICeritaPraktikItemResponse,
  ICeritaPraktikRateRequest,
} from 'types/cerita-praktik'
import type { UseMutationOptions, UseQueryOptions } from 'react-query'

const basePath = '/guru/guru-komunitas/v1/articles'

export const useApiPutRate = (
  id: string,
  opts?: UseMutationOptions<any, any, ICeritaPraktikRateRequest>
) => {
  return useMutationApi<any, any, ICeritaPraktikRateRequest>(
    `${basePath}/${id}/rate`,
    {
      axiosConfig: {
        method: 'PUT',
      },
      mutationConfig: {
        ...opts,
        useErrorBoundary: false,
      },
    }
  )
}

export function useAPIGetCeritaPraktikById(
  id: string,
  opts?: UseQueryOptions<CommonResponse<ICeritaPraktikItemResponse>>
) {
  return useQueryApi<CommonResponse<ICeritaPraktikItemResponse>>(
    `${basePath}/${id}`,
    {
      queryConfig: {
        retry: false,
        ...opts,
      },
      errorHandlerFn: (status, path, error) => {
        handleCommonErrors(status ?? 500, path, error)
      },
    }
  )
}
